angular.module('internal.resetpassword',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.resetpassword', {
            url: '/resetpassword/:token',
            views: {
                'content': {
                    templateUrl: 'js/internal/reset-password/reset-password.view.html',
                    controller:'resetPasswordContrl'
                }
            }
        });
    }]);